import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bulk-generation',
  templateUrl: './bulk-generation.component.html',
  styleUrls: ['./bulk-generation.component.scss']
})
export class BulkGenerationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
